/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable functional/immutable-data */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable @typescript-eslint/restrict-template-expressions */

import { OidcClient, OidcClientSettings } from "oidc-client";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { getExternalClientIdFromCookies } from "./getExternalClientIdCookie";
import { getRedirectUri } from "./getRedirectUri";

const externalClientId =
  getExternalClientIdFromCookies() ?? sessionStorage.getItem("MkHcClientId");
const externalIdpName = sessionStorage.getItem("MkHcIdpName");

const oidcSettings = {
  authority: `${window.location.origin}${getPartnerPathnameClient(
    true
  )}/v1/oauth2`,
  client_id: externalClientId,
  redirect_uri: getRedirectUri(),
  response_type: "code",
  scope: "openid email profile",
  // `audience` is not recognized by typescript
  // ... and audience also fails library parsing
  // ... we hack around it with an XHR interceptor
  audience: "pkcetester test-audience",
  response_mode: "query",
  filterProtocolClaims: true,
  loadUserInfo: true,
} as OidcClientSettings;

if (externalIdpName !== undefined && externalIdpName !== "") {
  oidcSettings.extraQueryParams = {
    idp_name: externalIdpName,
  };
}

export function getOidcClient() {
  const idpAdditionalScope = localStorage.getItem("idpAdditionalScope") ?? "";
  const oidcSettingWithScope = {
    ...oidcSettings,
    scope: `${oidcSettings.scope} ${idpAdditionalScope}`,
  };

  return new OidcClient(oidcSettingWithScope);
}
